import { render, staticRenderFns } from "./EditBankAccountDialog.vue?vue&type=template&id=d6054560&"
import script from "./EditBankAccountDialog.vue?vue&type=script&lang=js&"
export * from "./EditBankAccountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports